import { generateSecureId } from '@/utils/idGenerator/idGenerator'

import type { AccelerationContentDetails, AccelerationDetailRichItem } from '../AccelerationForm.types'

export const createDetailRichItem = (prefix = 'detail'): AccelerationDetailRichItem => ({
  id: generateSecureId(prefix),
  html: ''
})

/** Maps API/string-only arrays into rich items with stable ids */
export const normalizeDetailItemsArray = (
  raw: unknown,
  prefix: string,
  fallbackSingleEmpty: boolean
): AccelerationDetailRichItem[] => {
  if (!raw || !Array.isArray(raw) || raw.length === 0) {
    return fallbackSingleEmpty ? [createDetailRichItem(prefix)] : []
  }
  return raw.map((item, index) => {
    if (typeof item === 'string') {
      return { id: generateSecureId(`${prefix}-${index}`), html: item }
    }
    if (
      item &&
      typeof item === 'object' &&
      'id' in item &&
      'html' in item &&
      typeof (item as AccelerationDetailRichItem).id === 'string'
    ) {
      return item as AccelerationDetailRichItem
    }
    return { id: generateSecureId(`${prefix}-${index}`), html: '' }
  })
}

/** API / loaders may send HTML strings per item until full rich-shape is persisted */
export type AccelerationContentDetailsNormalizationInput = Omit<
  Partial<AccelerationContentDetails>,
  'steps' | 'rules'
> & {
  steps?: AccelerationDetailRichItem[] | string[] | null
  rules?: AccelerationDetailRichItem[] | string[] | null
}

export const normalizeAccelerationContentDetails = (
  partial?: AccelerationContentDetailsNormalizationInput | null
): AccelerationContentDetails => ({
  pageTitle: partial?.pageTitle ?? '',
  pageDescription: partial?.pageDescription ?? '',
  steps: normalizeDetailItemsArray(partial?.steps, 'step', true),
  rules: normalizeDetailItemsArray(partial?.rules, 'rule', true)
})

export const detailItemsToHtmlStrings = (items: AccelerationDetailRichItem[]): string[] => items.map((x) => x.html)
